<script setup lang="ts">
const cssHref = useState<string | null>("site-css", () => null);
useHead(() => ({
  link: cssHref.value
    ? [{ rel: "stylesheet", href: cssHref.value, tagPriority: 999 }]
    : [],
}));
</script>

<template>
  <div class="body flex h-full min-h-0 flex-col">
    <nuxt-loading-indicator />

    <slot />
  </div>
</template>

<style>
html {
  @apply h-full;
}

body {
  @apply h-full;
}
</style>
